export const EnterFullscreen = ({ color = 'black' }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    data-qa="fullscreen_icon"
  >
    <g filter="url(#filter0_d)">
      <path d="M15 3H21V9" stroke={color} strokeWidth="1.5" />
      <path d="M11 3H5V9" stroke={color} strokeWidth="1.5" />
      <path d="M15 19H21V13" stroke={color} strokeWidth="1.5" />
      <path d="M11 19H5L5 13" stroke={color} strokeWidth="1.5" />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0.25"
        y="0.25"
        width="25.5"
        height="25.5"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1819 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);
